// extracted by mini-css-extract-plugin
export default {"page-name-wrapper":"PageName_page-name-wrapper__q+Dre","page-name":"PageName_page-name__UKnng","total-records":"PageName_total-records__n6CKN"};